<template>
  <!-- <div class="maximum-box"> -->
  <el-container>
    <el-header>
      <div class="info-box">
        <div class="describe-text"><span>跟踪号：</span>{{ ticketCode }}</div>
      </div>
    </el-header>
    <el-main>
      <div class="subject-box">
        <el-upload
          ref="upload"
          :data="uploaddata"
          multiple
          :action="uploaddUrl"
          list-type="picture-card"
          :on-remove="handleRemove"
          :on-success="uploadingSuccess"
          :headers="{ staffId: staffId, staffName: staffName }"
          :file-list="filelist"
          accept=".png, .jpg, .jpeg"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过9张图片
          </div>
        </el-upload>
      </div></el-main
    >
    <el-footer>
      <div class="btn">
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="handluCloses">取 消</el-button> -->
          <el-button
            class="submitQCImg"
            type="primary"
            @click="confirmPutinStorage()"
            >提交质检图片</el-button
          >
        </span>
      </div></el-footer
    >
  </el-container>

  <!-- </div> -->
</template>

<script>
import { getKeyImg, deleteImg } from "@/api/PutInStorageOrder";
import {
  loading,
  loadingClose,
  message,
  dateFormat,
  confirmMsg,
} from "@/utils/common";
export default {
  data() {
    return {
      //uploaddUrl: `http://test.wms.java.api.nantang-tech.com/multipartFile/upload/`,
      uploaddUrl: `http://wms.java.nantang-tech.com/multipartFile/upload/`,
      dialogImageUrl: "",
      filelist: [],
      ticketCode: "",
      staffId: "",
      staffName: "",
      uploaddata: { key: "" },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 获取信息
    getInfo() {
      this.ticketCode = this.getParmeter("ticketCode").split("#")[0];
      this.uploaddata.key = this.ticketCode;
      this.staffName = this.getParmeter("userName");
      sessionStorage.setItem("staff-id", this.staffId);
      sessionStorage.setItem("name", this.staffName);
      this.getKeyImg(this.ticketCode);
    },
    // 解析url
    getParmeter(variable) {
      if (window.location.href.split("?")[1].length) {
        let query = window.location.href.split("?")[1]; // 这里query的结果是：   promotion_code=ZB06AKXFSR&sku=100
        let vars = query.split("&"); // 这里vars的结果是：   ["promotion_code=ZB06AKXFSR", "sku=100"]
        for (let i = 0; i < vars.length; i++) {
          //然后循环
          let pair = vars[i].split("="); //  循环第一次结果pair ["promotion_code", "ZB06AKXFSR"]  循环第二次结果pair ["sku", "100"]
          if (pair[0] === variable) {
            // 做判断 如果参数名和我们的实参一样
            console.log(pair, "pair");
            return pair[1]; // 就返回对应的值
          }
        }
        return "";
      }
    },

    // 提交质检图片
    async confirmPutinStorage() {
      this.$router.push("/finish");
    },
    // 文件上传之前
    beforeupload(file) {
      // console.log(file,'file'); //  10,485,760 相当月10兆
      if (file.size > 10485760) {
        console.log("文件过大");
        message("warning", "文件过大,请重新上传少于10M文件！");
        return false;
      }
      this.data.key = this.ticketCode;
    },
    //   上传成功
    uploadingSuccess(response, file, fileList) {
      // console.log(response, file, fileList, 'response, file, fileList');
      const { code, data } = response;
      if (code === 0) {
        data.map((item) => {
          this.filelist.push({ url: item.url, id: item.id });
        });
        message("success", "上传成功");
      }
      // console.log(this.filelist, 'this.filelist');
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      deleteImg(file.id)
        .then((res) => {
          if (res.code == 0) {
            message("success", "图片删除成功!");
            this.getKeyImg(this.ticketCode);
          }
        })
        .catch((err) => {});
    },
    handlePictureCardPreview(file) {},
    //获取质检上传图片列表
    getKeyImg(params) {
      this.filelist = [];
      getKeyImg(params)
        .then((res) => {
          console.log("质检图片列表:", res);
          if (res.code == 0) {
            //this.checkimages = res.data;

            if (res.data.length > 0) {
              res.data.forEach((item) => {
                this.filelist.push({
                  url: item.image,
                  id: item.id,
                });
              });
            }
          }
        })
        .catch((err) => {});
    },
  },
  mounted() {
    // console.log(process.env,'process.env');
    // console.log(process.env.VUE_APP_API,'process.env.VUE_APP_API');
    // console.log(window.location.href.split('?'),'window.location.href.split("?"")');
  },
};
</script>

<style lang="less" scoped>
.img-box {
  width: 100px;
  height: 200px;
  float: left;
  margin-right: 20px;
  // background-color: red;
  img {
    width: 100px;
    height: 100px;
  }
}
.el-header {
  height: 40px !important;
  //  background-color: red;
}
.describe-text {
  line-height: 29px;
}

.info-box {
  height: 20%;
  // background: red;
  // border: 1px solid rgb(223, 217, 217);
}
.subject-box {
  height: 40%;
  // background: yellow;
  // border: 1px solid red;
}
.btn {
  text-align: center;
  .el-button {
    width: 100%;
    font-size: 20px;
  }
}
</style>
